/**
 * Development middleware for the tenant override query parameter.
 *
 * The heavy lifting (cookie patching during SSR) is handled by
 * server/middleware/dev-tenant.ts, which runs before Nuxt plugins. This route
 * middleware only strips `?tenant=` from the URL once the cookie is set, so a
 * shared link does not keep re-pinning the tenant on every navigation.
 */
export default defineNuxtRouteMiddleware((to) => {
	if (!import.meta.dev || !import.meta.client) return;
	if (!to.query.tenant) return;

	const url = new URL(window.location.href);
	url.searchParams.delete('tenant');
	window.history.replaceState({}, '', url.toString());
});
